export const COLLECTIONS = {
  favorites: 'favorites',
};
